const TransactionEvent = {
  fetchReservation: 'transaction/fetch-reservation',
  onEdit: 'transaction/on-edit',
  onEditDetail: 'transaction/on-edit-detail',
  onEditAccommodationTax: 'transaction/on-edit-accommodation-tax',
  onUpdateAccommodationTax: 'transaction/on-update-accommodation-tax'
}

export default TransactionEvent
